import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import heroHome from "../../img/Image-home.png";
import BannerIted from "../../img/Banner-ited.png";
import BannerInovaaeDocente from "../../img/Banner-inovae-docente.png"

function HeroCarousel() {

    const [indiceAtual, setIndiceAtual] = useState(0);

    const slides = [
        {
            titulo: "Home",
            imagem: heroHome,
            tipo: "home"
        },
        {
            titulo: "SENAI ITED BA",
            imagem: BannerIted,
            tipo: "externo",
            link: "#"
        },
        {
            titulo: "Inova AÊ",
            imagem: BannerInovaaeDocente,
            tipo: "externo",
            link: "https://ead.fieb.org.br/sites/inovae/"
        },
        // {
        //     titulo: "Teste",
        //     imagem: heroHome,
        //     tipo: "projeto",
        //     projetoId: "1",
        // }
    ];

    const navigate = useNavigate();

    const total = slides.length;

    useEffect(function () {

        const intervalo = setInterval(function () {

            setIndiceAtual(function (valorAnterior) {

                if (valorAnterior === total - 1) {
                    return 0;
                }

                return valorAnterior + 1;

            });

        }, 5000); // tempo em ms (5 segundos)

        return function () {
            clearInterval(intervalo);
        };

    }, [total]);

    function irParaDestino(slide) {

        if (slide.tipo === "home") {
            navigate("/");
            return;
        }

        if (slide.tipo === "projeto") {
            navigate("/projeto/" + slide.projetoId);
            return;
        }

        if (slide.tipo === "externo") {
            window.open(slide.link, "_blank");
            return;
        }

    }

    if (!slides || slides.length === 0) {
        return null;
    }

    const slideAtual = slides[indiceAtual];

    return (
        <div
            className="hero"
        >
            <img
                src={slideAtual.imagem}
                alt={slideAtual.titulo}
                className="hero-imagem"
                onClick={function () {
                    irParaDestino(slideAtual);
                }}
                style={{ cursor: "pointer" }}
            />
            <div className="hero-overlay">
                {indiceAtual === 0 && (
                    <div className="hero-texto">
                        <span className="linha pequena">PORTFÓLIO</span>
                        <span className="linha gigante">TECNOLOGIAS</span>
                        <span className="linha gigante" style={{ color: "white" }}>
                            EDUCACIONAIS
                        </span>
                    </div>
                )}

            </div>

            <div className="hero-indicadores">

                {slides.map(function (slide, indice) {

                    const ativo = indice === indiceAtual;
                    const ultimo = indice === slides.length - 1;

                    return (
                        <span key={indice}>

                            <span
                                className={`hero-indicador ${ativo ? "ativo" : ""}`}
                                onClick={function () {
                                    setIndiceAtual(indice);
                                }}
                            >
                                {slide.titulo}
                            </span>

                            {!ultimo && <span className="hero-separador"> | </span>}

                        </span>
                    );

                })}

            </div>
        </div>
    );
}

export default HeroCarousel;